export const APPID = -1;
export const NODE_ENV = {
	DEVELOPMENT: 'development',
	PRODUCTION: 'production'
}

export const ERROR_IMAGE_TYPE = {
	INFO: 'INFO',
	DOWNLOAD: 'DOWNLOAD',
	TIME: 'TIME',
}